import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import GemCard from '../components/GemCard';
import { fetchGems } from '../api';
import './Retail.css';

const FILTERS = ['All', 'Precious', 'Semi-Precious', 'Classical', 'Rare'];

export default function Retail() {
  const navigate = useNavigate();
  const [gems, setGems] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [activeFilter, setActiveFilter] = useState('All');
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchGems({ category: 'Retail' })
      .then(data => {
        setGems(data);
        setFiltered(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    let result = gems;
    if (activeFilter !== 'All') {
      result = result.filter(g => g.category === activeFilter || g.gemType === activeFilter);
    }
    if (search) {
      result = result.filter(g => g.name?.toLowerCase().includes(search.toLowerCase()));
    }
    setFiltered(result);
  }, [activeFilter, search, gems]);

  return (
    <div className="retail-page">
      <Navbar />
      <div className="retail-content">
        <div className="retail-header">
          <button className="back-btn-retail" onClick={() => navigate(-1)}>‹</button>
          <h1>Our Gem Collection</h1>
          <p>Explore our hand-selected gemstones, sourced directly from Sri Lanka's finest mines.</p>
        </div>

        <div className="retail-controls">
          <div className="retail-filters">
            {FILTERS.map(f => (
              <button
                key={f}
                className={`filter-btn ${activeFilter === f ? 'active' : ''}`}
                onClick={() => setActiveFilter(f)}
              >
                {f}
              </button>
            ))}
          </div>
          <input
            className="retail-search"
            placeholder="Search gems..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>

        {loading ? (
          <div className="retail-grid">
            {Array(9).fill(0).map((_, i) => (
              <div key={i} className="skeleton-card" />
            ))}
          </div>
        ) : filtered.length === 0 ? (
          <div className="no-gems">
            <p>No gems found. Try a different filter or search term.</p>
          </div>
        ) : (
          <div className="retail-grid">
            {filtered.map(gem => <GemCard key={gem._id} gem={gem} />)}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
